import React from 'react';

const RaiseTheBarLogo = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 200 50"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    data-testid="raiseTheBarLogo"
    style={{
      fillRule: 'evenOdd',
      clipRule: 'evenodd',
      strokeLinejoin: 'round',
      strokeMiterlimit: 2,
    }}
  >
    <g id="Artboard2" transform="matrix(3.88823,0,0,2.3121,-16.0815,-223.396)">
      <rect
        x="4.136"
        y="96.621"
        width="51.437"
        height="21.625"
        style={{ fill: 'none' }}
      />
      <g transform="matrix(0.156586,0,0,0.263328,10.5656,98.3616)">
        <path
          d="M90.59,30.89L81.16,30.89L76.21,20.64L72.82,20.64L72.82,30.89L64.52,30.89L64.52,0.48L78.12,0.48C85.24,0.48 89.98,3.17 89.98,10.38C89.98,14.94 87.85,17.76 84.51,19.29L90.59,30.89ZM81.6,10.6C81.6,8.69 80.56,7.34 77.91,7.34L72.83,7.34L72.83,13.99L77.78,13.99C80.52,13.99 81.6,12.77 81.6,10.6Z"
          style={{ fill: 'rgb(33,33,33)', fillRule: 'nonzero' }}
        />
      </g>
      <g transform="matrix(0.156586,0,0,0.263328,10.5656,98.3616)">
        <path
          d="M122.95,30.89L113.83,30.89L112.18,25.55L103.06,25.55L101.41,30.89L92.37,30.89L103.4,0.48L111.91,0.48L122.94,30.89L122.95,30.89ZM110.13,18.86L109.57,16.86C108.48,12.95 108.01,11.3 107.62,9.26C107.23,11.3 106.75,13 105.67,16.86L105.11,18.86L110.15,18.86L110.13,18.86Z"
          style={{ fill: 'rgb(33,33,33)', fillRule: 'nonzero' }}
        />
      </g>
      <g transform="matrix(0.156586,0,0,0.263328,10.5656,98.3616)">
        <rect
          x="124.73"
          y="0.48"
          width="8.6"
          height="30.41"
          style={{ fill: 'rgb(33,33,33)', fillRule: 'nonzero' }}
        />
      </g>
      <g transform="matrix(0.156586,0,0,0.263328,10.5656,98.3616)">
        <path
          d="M162.13,21.55C162.13,28.5 156.87,31.37 149.58,31.37C144.67,31.37 139.94,29.76 136.76,27.68L140.84,21.08C143.06,22.6 146.92,24.12 149.75,24.12C152.75,24.12 153.7,23.6 153.7,22.16C153.7,21.03 152.61,20.34 148.53,19.38C141.19,17.69 137.67,15.69 137.67,9.61C137.67,3.88 142.32,0.01 149.66,0.01C154.83,0.01 158.57,1.27 161.78,3.53L157.7,10.13C155.01,8.31 152.31,7.26 149.23,7.26C146.71,7.26 146.1,8.04 146.1,9.13C146.1,10.22 147.19,10.78 151.1,11.69C158.75,13.51 162.13,15.86 162.13,21.55Z"
          style={{ fill: 'rgb(33,33,33)', fillRule: 'nonzero' }}
        />
      </g>
      <g transform="matrix(0.156586,0,0,0.263328,10.5656,98.3616)">
        <path
          d="M189.24,30.89L165.65,30.89L165.65,0.48L188.93,0.48L188.93,7.56L173.99,7.56L173.99,11.6L183.98,11.6L183.98,18.59L173.99,18.59L173.99,23.8L189.24,23.8L189.24,30.89Z"
          style={{ fill: 'rgb(33,33,33)', fillRule: 'nonzero' }}
        />
      </g>
      <g transform="matrix(0.156586,0,0,0.263328,10.5656,98.3616)">
        <path
          d="M89.99,45.82L81.47,45.82L81.47,68.89L73.04,68.89L73.04,45.82L64.53,45.82L64.53,38.48L89.99,38.48L89.99,45.82Z"
          style={{ fill: 'rgb(33,33,33)', fillRule: 'nonzero' }}
        />
      </g>
      <g transform="matrix(0.156586,0,0,0.263328,10.5656,98.3616)">
        <path
          d="M119.78,68.89L111.18,68.89L111.18,56.9L101.71,56.9L101.71,68.89L93.11,68.89L93.11,38.48L101.71,38.48L101.71,49.56L111.18,49.56L111.18,38.48L119.78,38.48L119.78,68.89Z"
          style={{ fill: 'rgb(33,33,33)', fillRule: 'nonzero' }}
        />
      </g>
      <g transform="matrix(0.156586,0,0,0.263328,10.5656,98.3616)">
        <path
          d="M147.76,68.89L124.17,68.89L124.17,38.48L147.45,38.48L147.45,45.56L132.51,45.56L132.51,49.6L141.5,49.6L141.5,56.59L132.51,56.59L132.51,61.8L147.76,61.8L147.76,68.89Z"
          style={{ fill: 'rgb(33,33,33)', fillRule: 'nonzero' }}
        />
      </g>
      <g transform="matrix(0.156586,0,0,0.263328,10.5656,98.3616)">
        <path
          d="M186.68,59.07C186.68,65.28 182.9,68.89 175.25,68.89L160.65,68.89L160.65,38.48L175.33,38.48C182.89,38.48 185.97,41.3 185.97,46.39C185.97,49.69 184.36,51.17 182.32,52.34C185.06,53.51 186.66,55.64 186.66,59.07L186.68,59.07ZM177.73,47.51C177.73,46.16 177.08,45.12 175.08,45.12L168.74,45.12L168.74,49.9L175.08,49.9C177.03,49.9 177.73,48.94 177.73,47.51ZM178.43,59.24C178.43,57.46 177.43,56.33 175.43,56.33L168.74,56.33L168.74,62.24L175.39,62.24C177.48,62.24 178.43,60.98 178.43,59.24Z"
          style={{ fill: 'rgb(33,33,33)', fillRule: 'nonzero' }}
        />
      </g>
      <g transform="matrix(0.156586,0,0,0.263328,10.5656,98.3616)">
        <path
          d="M217.74,68.89L208.62,68.89L206.97,63.55L197.85,63.55L196.2,68.89L187.16,68.89L198.19,38.48L206.7,38.48L217.73,68.89L217.74,68.89ZM204.92,56.86L204.36,54.86C203.27,50.95 202.8,49.3 202.41,47.26C202.02,49.3 201.54,51 200.46,54.86L199.9,56.86L204.94,56.86L204.92,56.86Z"
          style={{ fill: 'rgb(33,33,33)', fillRule: 'nonzero' }}
        />
      </g>
      <g transform="matrix(0.156586,0,0,0.263328,10.5656,98.3616)">
        <path
          d="M246.37,68.89L236.94,68.89L231.99,58.64L228.6,58.64L228.6,68.89L220.3,68.89L220.3,38.48L233.9,38.48C241.02,38.48 245.76,41.17 245.76,48.38C245.76,52.94 243.63,55.76 240.29,57.29L246.37,68.89ZM237.38,48.6C237.38,46.69 236.34,45.34 233.69,45.34L228.61,45.34L228.61,51.99L233.56,51.99C236.3,51.99 237.38,50.77 237.38,48.6Z"
          style={{ fill: 'rgb(33,33,33)', fillRule: 'nonzero' }}
        />
      </g>
      <g transform="matrix(0.156586,0,0,0.263328,10.5656,98.3616)">
        <path
          d="M0,9.13L0,0.52L47.54,0.52L47.54,9.12L0,9.12L0,9.13Z"
          style={{ fill: 'rgb(33,33,33)', fillRule: 'nonzero' }}
        />
      </g>
      <g transform="matrix(0.156586,0,0,0.263328,10.5656,98.3616)">
        <path
          d="M14.38,30.9L47.53,30.9L47.53,22.3L0,22.3L0,68.81L8.6,68.81L8.6,37.49C15.75,47.04 28.46,60.51 47.61,68.8L47.61,59.41C31.19,51.33 20.27,39.04 14.38,30.9Z"
          style={{ fill: 'rgb(40,125,247)', fillRule: 'nonzero' }}
        />
      </g>
    </g>
  </svg>
);

export default RaiseTheBarLogo;
